




import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import { PAGInit } from 'libpag'
import { $fetchPag } from '@/api'

@Component({})
export default class Stage extends Vue {
  @State('pagIns') pagIns
  // tips bmp格式的pag需要用户之前交互过才能播放
  @State('canAutoPlay') canAutoPlay
  @Mutation('setPagIns') setPagIns

  @Prop(String)
  pagSrc!: ''
  @Prop({ type: Boolean, default: false })
  autoPlay?: boolean
  @Prop(Boolean)
  isManualLoadFile!: false
  @Prop({ type: Boolean, default: false })
  useScale?: boolean
  @Prop({ type: Number, default: 1 })
  scaleMode?: number
  //  1 once  0  无数次
  @Prop({ type: Number, default: 1 })
  loop?: number

  pagView: any
  pagFile: any

  @Watch('pagSrc')
  async watchPagSrcChange(newVal) {
    let pagView = this.pagView
    const PAG = this.pagIns
    if (pagView) {
      pagView.pause()
      let buffer2 = await $fetchPag(newVal).then((response) => response.data)
      let pagFile2 = await PAG.PAGFile.load(buffer2)
      // 需要重新赋值newFile
      this.pagFile = pagFile2
      pagView.setComposition(pagFile2)
      pagView.setRepeatCount(0)
      pagView.setProgress(0)
      pagView.play()
    }
  }

  async mounted() {
    const canvasEle = this.$refs['pagRef'] as HTMLCanvasElement
    if (this.pagIns) {
      await this.loadPagFile(this.pagSrc, canvasEle)
      if (this.canAutoPlay && this.autoPlay) {
        this.pagView && this.pagView.play()
      }
    } else {
      await this.initPag()
      await this.loadPagFile(this.pagSrc, canvasEle)
      if (this.canAutoPlay && this.autoPlay) {
        this.pagView && this.pagView.play()
      }
    }
  }

  beforeDestroy() {
    // 清除实例
    this.pagView && this.pagView.destroy()
  }

  // 初始化pag
  async initPag() {
    await PAGInit({
      locateFile: () =>
        '//i0.hdslb.com/bfs/ogv/activity/film-history/libpag-1.wasm',
    })
      .then((PAG) => {
        console.log('%c PAG ------> ', 'color:#0f0;', PAG)
        this.setPagIns(PAG)
      })
      .catch(() => {
        // console.log('%c err ------> ', 'color:#0f0;', err)
        Vue.prototype.$toast.info('初始化失败，请稍后再试～')
      })
  }

  // 下载pag文件并且返回file文件
  async loadPagFile(url: string, ele: any) {
    await $fetchPag(url)
      .then(async (response) => {
        let file = response.data
        if (this.pagIns) {
          try {
            const PAG = this.pagIns
            let pagFile = await PAG.PAGFile.load(file)
            this.pagFile = pagFile
            let currDom: any = ele
            currDom.width = pagFile.width()
            currDom.height = pagFile.height()
            this.pagView = await PAG.PAGView.init(
              pagFile,
              ele,
              { useScale: this.useScale, firstFrame: false } // tips 否则第一帧会闪一下
            )
            // 次数
            this.pagView.setRepeatCount(this.loop)
            this.pagView.setScaleMode(this.scaleMode)

            console.log('%c onReady9999 ------> ', 'color:#0f0;', this.pagSrc)
            this.$emit('onReady')
          } catch (error) {
            console.log('%c loadPagFile ------> ', 'color:#0f0;', error)
          }
        }
      })
      .catch((err) => {
        console.log('%c err123 ------> ', 'color:#0f0;', err)
      })
  }

  onPlay() {
    console.log('%c onPlay ------> ', 'color:#0f0;', this.pagSrc, this.pagView)
    this.pagView && this.pagView.play()
  }

  onPause() {
    this.pagView && this.pagView.pause()
  }

  getPagView() {
    return this.pagView
  }

  getPagFile() {
    return this.pagFile
  }

  async manualLoadFile() {
    const canvasEle = this.$refs['pagRef']
    if (canvasEle) {
      await this.loadPagFile(this.pagSrc, canvasEle)
    } else {
      throw new Error('canvasEle is not exist')
    }
  }
}
